export const parseQcAbnahmeAnswers = (
  metadata: any,
  type: "qc" | "abnahme" | "appointment"
) => {
  const keys = Object.keys(metadata);

  const tempQuestions = keys.map((item: string) => {
    let prefix = "";
    switch (type) {
      case "qc":
        prefix = "QC failed";
        break;
      case "abnahme":
        prefix = "Abnahme failed";
        break;
      case "appointment":
        prefix = "Appointment not completed";
        break;
    }
    let question = "";
    switch (item) {
      case "description":
        question = `${prefix}/Write here what happened`;
        break;
      case "whatToSchedule":
        question = "What do we have to schedule?";
        break;
      case "days":
        question = "How many days?";
        break;
      case "missingMaterial":
        question = `${prefix}/Which material is missing?`;
        break;
      case "dispoNotes":
        question = `${prefix}/Dispo notes`;
        break;
      case "fieldInstruction":
        question = `${prefix}/What needs to be done? Instruction for field`;
        break;
    }
    return {
      question: question,
      answer: metadata ? metadata[item] : "",
    };
  });
  return tempQuestions;
};
